/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Meta_DescInputs */

const en_hub_meta_desc = /** @type {(inputs: Hub_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export a Bystep plan as native files for Kiro, Spec Kit, OpenSpec, Backlog.md, Task Master, Claude Code, GitHub Issues or Linear — and import the same formats back.`)
};

const id_hub_meta_desc = /** @type {(inputs: Hub_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor rencana Bystep sebagai berkas asli untuk Kiro, Spec Kit, OpenSpec, Backlog.md, Task Master, Claude Code, GitHub Issues, atau Linear — dan impor format yang sama kembali.`)
};

/**
* | output |
* | --- |
* | "Export a Bystep plan as native files for Kiro, Spec Kit, OpenSpec, Backlog.md, Task Master, Claude Code, GitHub Issues or Linear — and import the same format..." |
*
* @param {Hub_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_meta_desc = /** @type {((inputs?: Hub_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_meta_desc(inputs)
	return en_hub_meta_desc(inputs)
});